import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

export const useRemoveAvalaraMapping = () => {
  const { displayNotification } = useNotifications()

  const deleteMappingMutator = useMutation(
    dashboardv99990101Client.deleteTaxCategoryAvalaraMapping
  )

  return async (taxCategoryId: string) => {
    await deleteMappingMutator.mutateAsync(
      {
        id: taxCategoryId
      },
      {
        onSuccess: () => {
          displayNotification('Tax code removed from category', {
            type: 'success'
          })
        },
        onError: () => {
          displayNotification('Failed to remove tax code from category', {
            type: 'error'
          })
        }
      }
    )
  }
}
